<script>
import { mapGetters } from "vuex"
import ThemedLoading from "@/components/ThemedLoading.vue"

export default {
    name: "CreateCompanyForm",
    components: { ThemedLoading },
    emits: ["reset", "created"],
    data() {
        return {
            isLoading: false,
            form: {
                name: "",
                countryId: null,
                contactEmail: null,
                contactPhone: null,
            },
            countries: [],
        }
    },
    created() {
        this.fetchCountries()
    },
    methods: {
        fetchCountries() {
            this.isLoading = true

            this.axios
                .get(`/countries`)
                .then((response) => {
                    const data = response.data.data
                    this.countries = data.countries
                })
                .catch((error) => {})
                .finally(() => {
                    this.isLoading = false
                })
        },
        async copyRegistrationUrl() {
            await navigator.clipboard.writeText(this.registrationUrl)
        },
        normalizer(group) {
            return {
                id: group.id,
                label: group.name,
                children: group.children,
            }
        },
        handleCompanyForm() {
            this.isLoading = true

            this.axios
                .post(`/companies`, {
                    data: this.form,
                })
                .then((response) => {
                    const data = response.data.data
                    const company = data.company

                    this.$emit("created", company)
                })
                .catch((error) => {})
                .finally(() => {
                    this.isLoading = false
                })
        },
        handleReset() {
            this.$emit("reset")
        },
    },
}
</script>

<template>
    <div>
        <ThemedLoading
            :active="isLoading"
            :is-full-page="false"
            loader="bars"
            :opacity="0"
        ></ThemedLoading>
        <div class="row">
            <div class="col-md-12">
                <div class="card py-2">
                    <div class="card-body py-4">
                        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                            <form
                                @submit.prevent="handleSubmit(handleCompanyForm)"
                                @reset.prevent="handleReset"
                            >
                                <div class="row">
                                    <div class="col-md-12 mb-4">
                                        <ValidationProvider
                                            :vid="`name`"
                                            name="Name"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <div class="form-group">
                                                <label for="name">{{ $t("Name") }}</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    id="name"
                                                    placeholder="Name"
                                                    v-model="form.name"
                                                />
                                                <small class="form-text text-danger">{{
                                                    errors[0]
                                                }}</small>
                                            </div>
                                        </ValidationProvider>
                                        <ValidationProvider
                                            :vid="`country`"
                                            name="Country"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <div class="form-group">
                                                <label for="country">{{ $t("Country") }}</label>
                                                <v-select
                                                    placeholder="Country"
                                                    :options="countries"
                                                    label="name"
                                                    v-model="form.countryId"
                                                    :reduce="(country) => country.id"
                                                    required
                                                ></v-select>
                                                <small class="form-text text-danger">{{
                                                    errors[0]
                                                }}</small>
                                            </div>
                                        </ValidationProvider>
                                        <div class="form-group">
                                            <label for="contactEmail">{{
                                                $t("create_company_form.contact_email")
                                            }}</label>
                                            <input
                                                type="email"
                                                class="form-control"
                                                id="contactEmail"
                                                placeholder="Email"
                                                v-model="form.contactEmail"
                                            />
                                        </div>
                                        <div class="form-group">
                                            <label for="contactPhone">{{
                                                $t("create_company_form.contact_email")
                                            }}</label>
                                            <input
                                                type="tel"
                                                class="form-control"
                                                id="contactPhone"
                                                placeholder="Phone number"
                                                v-model="form.contactPhone"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-md-12 d-flex justify-content-end">
                                        <div class="form-group">
                                            <button
                                                class="btn btn-outline-secondary mr-2"
                                                type="reset"
                                            >
                                                {{ $t("Cancel") }}
                                            </button>
                                            <button class="btn btn-primary" type="submit">
                                                {{ $t("Create") }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
